<template>
    <VJoyLink :class="['mui-c-link', {'mui-c-link--icon': icon}]" :href="props.href" :target="props.target" :icon="icon">
        {{ props.text }}
    </VJoyLink>
</template>
<script setup lang="ts">
    import {VJoyLink} from '@maltjoy/core-vue';
    import type {JoyIconsId} from '@maltjoy/icons';

    const props = defineProps<{
        href: string;
        text: string;
        target?: string;
        icon?: JoyIconsId;
    }>();
</script>

<style lang="scss">
    a.mui-c-link.joy-link {
        &,
        &:visited {
            width: auto;
            text-decoration: underline;

            // text-underline-offset: 6px;
            // text-decoration-thickness: 2px;
            // text-decoration-color: var(--joy-color-neutral-70);
            // color: var(--joy-color-neutral-70);
        }

        &:hover {
            &,
            & *,
            & > span.joy-link__text {
                // text-decoration-color: var(--joy-color-neutral-50);
                // color: var(--joy-color-neutral-50);
            }
        }

        &.mui-c-link--icon {
            text-decoration: none;

            & > span.joy-icon {
                font-size: 10px;
            }

            & > span.joy-link__text {
                position: relative;
                top: -1px;
            }
        }
    }
</style>
